<template>
  <div class="container">
    <div class="card_header">
      <div class="card_header_inner">
        <div class="coupon-detail">
          <div class="coupon-detail_inner">
            <div class="coupon-detail_thunnail">
              <img :src="item.imageURL" :title="item.menuNm">
            </div>

            <div class="coupon-detail_content">
              <div class="coupon-detail_content--no">
                <span>[メニューNo.{{ item.menuNo }}]</span> 
                <h1>{{ item.menuNm }}</h1>
              </div>

              <div class="coupon-detail_content--pc">
                  <h2 >
                  {{ item.planNm }}
                  </h2>
                  <div>
                    <span v-if="item.type === 4 || item.type === 5">
                      有効期限 : {{ item.expireTo }}
                    </span>
                    <span v-else>
                      受付番号 : {{ item.acptNo }}
                    </span>
                  </div>
              </div>

            </div>
            <div 
              v-if="item.catLrgClassCd == '011'" 
              class="p-mypage-coupon-detail__logo-gourmet"  
            >
              <img :src="imgSrc" alt="TABE TIME" />
            </div>
          </div>

          <div class="coupon-detail_content--sm">
            <h2>
              {{ item.planNm }}
              </h2>
              <div>
                <span v-if="item.type === 4 || item.type === 5">
                  有効期限 : {{ item.expireTo }}
                </span>
                <span v-else>
                  受付番号 : {{ item.acptNo }}
                </span>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="card_content">

    </div>
    <div class="card_content">
      
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: {
      type: Object
    },
    opt: {
      type: Object
    }
  },
  data() {
    return {
      imgSrc: require('@/assets/images/BS_SPE_01/list.png')
    }
  }

}
</script>

<style lang="scss" scope>
@import "./styles.scss";
</style>